import { render } from "./AdminLayout.vue?vue&type=template&id=f1415048&scoped=true"
const script = {}

import "./AdminLayout.vue?vue&type=style&index=0&id=f1415048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1415048"]])

export default __exports__